export default __webpack_public_path__ + "static/media/9.cd908c67.jpg";